class IPDetectPopup extends HTMLElement {
    constructor() {
      super();
  
      this.modal = document.querySelector("#popup-country-redirect");

      this.currentUrl = window.location.href.replace(/%20/g, ""); // remove all occurrences of %20; or space

      this.showInUrl = this.modal.getAttribute("data-show-in-url");
      this.linkCountries = JSON.parse(this.modal.getAttribute("data-link-countries"));
      this.countryLink = '';

      this.btnYes = this.querySelector(".btn-yes");
      this.btnNo = this.querySelector(".btn-no");
      this.btnClose = this.querySelector(".close");
  
      this.btnYes.addEventListener("click", this.onYes.bind(this));
      this.btnNo.addEventListener("click", this.onNo.bind(this));
      this.btnClose.addEventListener("click", this.closePopup.bind(this));

      if (
        !localStorage.getItem("confirmation-popup-response") &&
        localStorage.getItem("confirmation-popup-response") != "yes"
      ) {
        // Check if the current URL is the same as the URL to show popup
        if (this.showInUrl && this.currentUrl == this.showInUrl || !this.showInUrl) {
          this.checkCountry();
        }
      }
    }
  
    checkCountry() {
      fetch("https://pro.ip-api.com/json/?key=FnoQ5kojLaFXcAM&fields=countryCode")
        .then((response) => response.text())
        .then((text) => {
          const countryCode = JSON.parse(text).countryCode;
          const euCountryCodes = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "GB", "CH"]
  
          // Check if country code is in the list of countries to show popup
          if (this.linkCountries[countryCode]) {
            this.countryLink = this.linkCountries[countryCode];
            this.showPopup();
          } 
          // Check if country code is in the list of EU countries
          else if (euCountryCodes.includes(countryCode)) {
            this.countryLink = this.linkCountries['EU'];
            this.showPopup();
          }
        })
        .catch((error) => console.error(error));
    }
  
    showPopup() {
      if (this.modal) {
        this.modal.classList.add("show");
        document.querySelector("body").style.overflow = "hidden";
      }
    }
  
    closePopup() {
      if (this.modal) {
        this.modal.classList.remove("show");
        document.querySelector("body").style.overflow = "auto";
      }
    }
  
    onYes(event) {
      localStorage.setItem("confirmation-popup-response", "yes");
      event.preventDefault();
      this.closePopup(); 
    }
  
    onNo(event) {
      event.preventDefault();
      window.location.assign(this.countryLink);
    }
  }
  
  customElements.define("ip-detect-popup", IPDetectPopup);